"use client"

import { Printer, ShoppingBag } from "lucide-react"
import Link from "next/link"
import type { ComponentProps } from "react"
import { cn } from "@/utilities"

interface ActionsProps extends ComponentProps<"div"> {
  orderNumber: string
}

export function Actions({ orderNumber, className, ...props }: ActionsProps) {
  const handlePrint = (): void => {
    window.print()
  }

  return (
    <div
      className={cn("flex flex-col gap-3 sm:flex-row", className)}
      {...props}
    >
      <Link
        className='inline-flex h-11 flex-1 items-center justify-center gap-2 rounded-lg bg-primary px-6 font-medium text-primary-foreground text-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
        href={`/conta/pedidos/${orderNumber}`}
      >
        Ver detalhes do pedido
      </Link>

      <button
        className='inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-input bg-background px-6 font-medium text-sm transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 print:hidden'
        onClick={handlePrint}
        type='button'
      >
        <Printer aria-hidden='true' className='size-4' />
        Imprimir
      </button>

      <Link
        className='inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-input bg-background px-6 font-medium text-sm transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
        href='/'
      >
        <ShoppingBag aria-hidden='true' className='size-4' />
        Continuar comprando
      </Link>
    </div>
  )
}
